import { render, staticRenderFns } from "./assignedVendorModel.vue?vue&type=template&id=61c289bd&scoped=true&"
import script from "./assignedVendorModel.vue?vue&type=script&lang=js&"
export * from "./assignedVendorModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c289bd",
  null
  
)

export default component.exports